import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ICurrentUser } from './user.interface';

export const userActions = createActionGroup({
  events: {
    getCurrentUser: emptyProps(),
    getCurrentUserCompleted: props<{ user: ICurrentUser }>(),
  },
  source: 'User',
});
